import * as React from "react";
import adminReducer from "../reducers/AdminReducer.js";
import { AdminContext } from "../contexts/AdminContext.js";
import { REACT_APP_NAME } from "../../config";

function AdminAuthProvider({ children }) {
  const [state, dispatch] = React.useReducer(adminReducer, {
    appName: REACT_APP_NAME,
    
    accessToken: localStorage.getItem("adminAccessToken"),
    refreshToken: localStorage.getItem("adminRefreshToken"),
    userData: {},
    
    dataLoading: false,
    error: null,
    message: null,
  });

  const value = [state, dispatch];

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
}

export default AdminAuthProvider;